



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IUserData, IUserRoles, userModule } from '@/store/modules/ModuleUser';
import serviceArticle from '@/service/ServiceArticles';
import { ISceneMode, SceneConstType, appModule, ISelectSceneAndMode } from '@/store/modules/ModuleApp';
import { IndexController } from '../../views/index/index';
import {
	bootStrapManager,
	getLocalStorage,
	IConfig,
	InterceptorLocalAuth,
	isLocalMode,
	setLocalStorage,
	removeLocalStorage,
	CrossDomainSync,
	configService
} from '@tencent/s2-client-vue-lib';
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import { setpsHeader, driverHeader } from '../../views/index/first-home-page/models/FirstHomePageGuide';
import SceneMixins from '@/libs/LibsModelSceneMixins';
import { mixins } from 'vue-class-component';
import { LOCAL_STORE_USER_INFO, CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, CROSS_DOMAIN_SYNC_OPTIONS } from '@/libs/LibsStatus';
import { reportCrossDomainSyncOperation } from '@/libs/LibsCrossDomainReport';
import { getCookie, setCookie } from '@/libs/LibsCookieUtils';
import { COOKIE_KEY_LANGUAGE, COOKIE_KEY_STATUS } from '@/libs/LibsConst';
import axios, { AxiosResponse } from 'axios';
import { AppEnum } from '@/service';
import serviceCommon from '@/service/ServiceCommon';
import { portalModule } from '@/store/modules/ModulePortal';
import { setJarvisLocale, KEY_LANG_COOKIE, goToRegister } from '@/libs/LibsLocate';

@Component
/** 头部组件 */
export default class ComponentHeader extends mixins(SceneMixins) {
	@Prop()
	public systemTitle!: string;

	@Prop()
	public entranceFlag!: any;

	/** 显示标题 */
	public systemTitleValue: string = '';

	/** 判断当前语言是否为中文 */
	private isZH: boolean = true;

	/** 是否正在退出 */
	public isOnLogout: boolean = false;

	/** 特殊定义axios */
	public axios: any;

	/** 轮询时间 */
	public timeOutNum: number = 500;

	/** 显示登录按钮 */
	public showAuthButton: boolean = false;

	/** 弹窗显示与否 */
	public dialogVisible: boolean = false;

	/** 登录信息 */
	public authInfo: string = '';

	/** 是否显示 */
	public isShowSceneModel: boolean = false;

	/** 用户选择历史记录列表 */
	public userHistoryList: any = {};
	public indexController!: IndexController;

	/** 引导页 */
	public driverVal: any = null;

	/** 循环 */
	public interval: any = null;

	/** 引导页本地记录 */
	public historyGuideData: any = {};

	/** 场景配置类 */
	public sceneConstType!: SceneConstType;

	/** 当前角色 */
	public currentRole: any = '';

	/** 当前选中的供应商 pVendorPartyId */
	public currentVendorId: string = '';

	/** 上一次成功切换的供应商 pVendorPartyId（用于切换失败时回滚 v-model） */
	public previousVendorId: string = '';

	/** "邀请注册"虚拟选项标识 */
	public readonly INVITE_REGISTER_VALUE: string = '__INVITE_REGISTER__';

	/**
	 * CrossDomainSync 实例，用于跨域/跨 Tab 数据共享
	 */
	public sync: any = new CrossDomainSync(CROSS_DOMAIN_SYNC_OPTIONS);

	/** vendorFullValue 取消监听函数 */
	private unsubscribe: (() => void) | null = null;

	/**
	 * 暂存 onChange 触发时尚未拉到 userDataList 的最新值；
	 * 待 fetchVendorList 完成后兜底再做一次匹配，解决握手回调早于接口返回的时序问题。
	 */
	private pendingVendorFullValue: string = '';

	/** 下拉列表展示数据 */
	public get vendorOptions(): Array<{ label: string; value: string }> {
		const options: Array<{ label: string; value: string }> = this.userDataList?.map((item: any) => ({
			label: item.vendorFullName,
			value: String(item.pvendorPartyId)
		}));

		// canSwitch 为 true 时，下拉末尾追加"邀请注册"入口
		if (this.canSwitch) {
			options.push({
				label: this.$t('common.invite_register') as string,
				value: this.INVITE_REGISTER_VALUE
			});
		}

		return options;
	}

	/** 是否展示供应商下拉选择（vendorSwitch 页面不展示） */
	public get showVendorSelect(): boolean {
		return this.userDataList?.length > 0;
	}


	/** 是否动态数据 */
	public get currentStatus(): string {
		return portalModule.currentStatus;
	}

	/** 角色列表 */
	public rolesList: Array<IUserRoles> = [];

	/** 是否本地模式 */
	public get isLocal(): boolean {
		return isLocalMode();
	}

	/** 注册组件名 */
	public get name(): string {
		return 'component-header';
	}

	/** 用户数据 */
	public get userData(): IUserData {
		this.currentVendorId = String(userModule.userData?.vendorId) || '';
		this.previousVendorId = String(userModule.userData?.vendorId) || '';
		return userModule.userData;
	}

	/** 场景SCENE CODE */
	public get sceneNameCode(): string {
		return appModule.sceneMode.model;
	}

	/** 获取帮助中心URL */
	public get getHelperCenterUrl(): string {
		let url: string = '';
		if (this.isSceneQCP()) {
			// QCP
			url = 'https://iwiki.woa.com/pages/viewpage.action?pageId=1556172044';
		} else if (this.isSceneIEG()) {
			// IEG
			url = 'https://iwiki.woa.com/pages/viewpage.action?pageId=1556172044';
		} else if (this.isSceneIDC()) {
			url = 'https://iwiki.woa.com/pages/viewpage.action?pageId=1556172044';
		} else {
			url = 'https://iwiki.woa.com/pages/viewpage.action?pageId=1556172044';
		}

		return url;
	}

	/** 当前用户下的主体数据列表 */
	public get userDataList(): IUserData[] {
		return userModule.userDataList;
	}

	/** 是否允许切换（接口返回 canSwitch，true 时下拉末尾追加"邀请注册"项） */
	public get canSwitch(): boolean {
		return userModule.canSwitch;
	}

	/** 从store传入 */
	@Watch('entranceFlag', { immediate: true, deep: true })
	public onEntranceFlagUpdate(newVal: any, oldVal: any): any {
		this.isShowSceneModel = newVal;
		// this.$forceUpdate();
	}

	/** 更新场景状态 */
	public toggleShowType(): void {
		const currentStatus = this.currentStatus === 'dynamic' ? 'static' : 'dynamic';
		// setCookie(COOKIE_KEY_STATUS, this.currentStatus);
		portalModule.saveScurrentStatus(currentStatus);
		const windowObj: any = window;
		windowObj.location.reload();
	}

	/** 更新场景状态 */
	public updateSceneStatus(val: boolean): boolean {
		return val;
	}

	/** created：读取初始值并监听 vendorFullValue 变更，存入 vuex */
	public created(): void {
		// 监听变更（其他 Tab / 子域修改时触发），同步到 vuex
		// 注册监听时上报一次
		this.sync.onChange(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, (newValue: string, oldValue: string) => {
			console.log('触发了onChange', newValue, oldValue);
			// 比较 initialVendorFullValue 和 userData.userId，不一致时从 vendorOptions 中查找匹配项并更新 userData
			const normalizedOldValue: string = oldValue === null || typeof oldValue === 'undefined' ? '' : String(oldValue);
			if (this.userDataList?.length > 1) {
				const matched: any = normalizedOldValue ? this.userDataList?.find((item: any) => String(item.pvendorPartyId) === normalizedOldValue) : null;
				if (matched && matched.pvendorPartyId) {
					userModule.setUserData({
						...this.userData,
						userId: matched.userId,
						vendorId: matched.pvendorPartyId,
						fullName: matched.vendorFullName
					});
				} else {
					userModule.setUserData({
						...this.userData,
						userId: '',
						vendorId: '',
						fullName: this.$t('common.no_supplier_info') as string
					});
				}
				configService.setCustomHeadersGetter(() => ({
					'pvendor-id': this.sync.get(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE) || ''
				}));
	
				// 每次回调触发时再上报
				reportCrossDomainSyncOperation('onChange', CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, normalizedOldValue);
				// 如果切换了供应商需要到/portal/index重新刷新，否则跳转到供应商切换页面
				if (matched && matched.pvendorPartyId) {
					window.location.href = '#/home/homePage';
				} else {
					goToRegister();
				}
			} else if (!this.userData?.vendorId || (String(this.userData?.vendorId) !== normalizedOldValue)) {
				window.location.href = '#/home/homePage';
			}

		});
	}

	/** hook */
	public mounted(): void {
		this.indexController = new IndexController();
		this.sceneConstType = new SceneConstType();

		this.systemTitleValue = this.systemTitle;
		this.getSceneDescription(this.sceneNameCode);
		this.axios = axios.create({
			timeout: 1000 * 600
		});
		// 固定语言为英文
		// this.$i18n.locale = 'en';
		// setCookie(COOKIE_KEY_LANGUAGE, this.$i18n.locale || 'en');
		setJarvisLocale(this.$i18n.locale === 'zh' ? 'zh_CN' : 'en_US');
		const currentLang = getCookie(KEY_LANG_COOKIE) || 'en_US';

		this.isZH = currentLang === 'en_US';

		// this.currentStatus = getCookie(COOKIE_KEY_STATUS) || 'dynamic';
		// portalModule.saveScurrentStatus(this.currentStatus);
	}

	/** 依据CODE获取场景名 */
	public getSceneDescription(scene: string): string {
		return this.sceneConstType?.getSceneDescription(scene);
	}

	/** 判断是否需要指引 */
	public guideData(): void {
		if (this.userHistoryList?.selectSceneModel?.modelName) {
			this.historyGuideData = getLocalStorage('guideData') || {};
			if (!this.historyGuideData || !this.historyGuideData?.secondHome) {
				const timeOut: any = setTimeout(() => {
					clearTimeout(timeOut);
					this.guide();
				}, 1000);
			}
		}
	}

	/** 引导事件 */
	public guide(): void {
		this.driverVal.defineSteps(setpsHeader);

		this.driverVal.start();

		// 设置不可点击
		this.driverVal.steps.forEach((el: any) => {
			el.node.style.pointerEvents = 'none';
		});

		// 指引完成 可以点击
		this.interval = setInterval(() => {
			if (!this.driverVal.isActivated) {
				this.driverVal.steps.forEach((el: any) => {
					el.node.style.pointerEvents = 'auto';

					// 存本地记录
					this.historyGuideData.secondHome = true;
					setLocalStorage('guideData', this.historyGuideData);
				});

				clearInterval(this.interval);
			}
		}, 100);
	}

	/** 更新登录信息 */
	private updateAuthInfo(e: any): void {
		this.dialogVisible = true;
	}

	/** 弹窗确认按钮点击,调用本地接口更新 */
	private async handleClose(): Promise<any> {
		if (this.authInfo) {
			const result: any = await serviceArticle.createArticle({ authInfo: this.authInfo });
			const windowObj: any = window;
			windowObj.location.reload();
		} else {
			this.$message.warning('请输入有效cookie');
		}

		// 关闭弹窗
		this.closePopUpWindow();
	}

	/** 关闭弹窗 */
	private closePopUpWindow(): void {
		this.dialogVisible = false;
	}

	/** 登出local */
	public async onLogoutLocal(): Promise<any> {
		// console.log('本地登出处理');
		// this.indexController.saveCurrentSeletedSceneMode({ selectSceneModel: {} });
		// if (isLocalMode()) {
		// 	// 本地模式退出
		// 	await new InterceptorLocalAuth().interceptorServerAuth();
		// }
	}

	/** 登出 */
	public onLogout(): void {
		// const url: string = `${window.location.protocol}//${window.location.host}/logout`;
		// console.log('登出处理');
		// // window.open(url);
		// this.indexController.saveCurrentSeletedSceneMode({ selectSceneModel: {} });
		// window.location.href = `//${window.location.host}/api/logout`;
		// this.indexController.saveCurrentSeletedSceneMode({ selectSceneModel: {} });

		this.clearUserLocalStorage();
	}

	/** 登录清除登录状态 */
	public clearUserLocalStorage(): void {
		console.log('登录清除登录状态..');

		window.location.href = `${window.location.protocol}//${window.location.host}/logout`;

		return;

		// this.isOnLogout = true;
		// try {
		// 	this.axios.interceptors.response.use(
		// 		(response: AxiosResponse): any => response,
		// 		(error: any): any => {
		// 			if (error.response.status === 401) {
		// 				// eslint-disable-next-line no-alert
		// 				alert('test');

		// 				window.location.href = `${window.location.protocol}//${window.location.host}/logout`;
		// 			}

		// 			return Promise.reject(error.response || {});
		// 		}
		// 	);

		// 	this.axios
		// 		.get(`${AppEnum.CASE_V3}${serviceCommon.pageHeaderUrl}`)
		// 		.then((res: any) => {
		// 			console.log('调用接口返回内容..', res);
		// 			const resData: any = res.data ? res.data : res;
		// 			if (resData.status === 0) {
		// 				this.timeOutInvoke();
		// 			}
		// 		})
		// 		['catch']((error: any) => {
		// 			if (error) {
		// 				const response: any = error.response ? error.response : error;
		// 				if (response.status === 401) {
		// 					removeLocalStorage(LOCAL_STORE_USER_INFO);
		// 					const baseUrl = window.location.host;
		// 					if (baseUrl === 'test-global-supplier.tencent.com') {
		// 						window.location.href = 'https://test-global-supplier.tencent.com';
		// 					} else {
		// 						let regularUrl: string = 'https://global-supplier.tencent.com';
		// 						if (baseUrl !== regularUrl) {
		// 							regularUrl = `${window.location.protocol}//${window.location.host}`;
		// 						}

		// 						window.location.href = regularUrl;
		// 					}
		// 				} else {
		// 					this.timeOutInvoke();
		// 				}
		// 			} else {
		// 				this.timeOutInvoke();
		// 			}
		// 		});
		// } catch (error) {
		// 	console.log('axios error==>', error);
		// 	this.timeOutInvoke();
		// }
	}

	/** 隔500MS再次调用 */
	public timeOutInvoke(): void {
		const timeOut: any = setTimeout(() => {
			console.log('延时处理..');
			clearTimeout(timeOut);
			this.clearUserLocalStorage();
		}, this.timeOutNum);
	}

	// /** 还原用户常用历史列表 */
	// protected restoreUserSelectedHistory(): void {
	// 	const storageKey: string = this.indexController.getUserCurrentSelectKey();
	// 	this.userHistoryList = getLocalStorage(storageKey) || {};
	// 	this.isShowSceneModel = this.getIsShowSceneModel(this.userHistoryList.selectSceneModel);
	// }

	/** 当前用户选择的场景内容 */
	public get selectSceneAndMode(): ISelectSceneAndMode {
		return appModule.selectSceneAndMode;
	}

	/** 监听场景变化 */
	@Watch('selectSceneAndMode', { deep: true })
	public handleSelectScene(newVal: any): void {
		console.log('ifNewVal', newVal);
		if (Object.keys(newVal).length) {
			this.userHistoryList = newVal;
			this.guideData();
		}
	}

	/** 切换场景 */
	public handleSwitchScence(): void {
		appModule.saveSelectSceneAndMode({});
		this.indexController.saveCurrentSeletedSceneMode({ selectSceneModel: {} });
		this.$router.push('/index');
	}

	/** 监听路由 */
	// @Watch('$route', { immediate: true, deep: true })
	// public handleRoute(newVal: any): void {
	// 	console.log('on route update..', newVal);
	// 	if (newVal.path !== '/index/index') {
	// 		this.isShowSceneModel = true;
	// 		this.$set(this, 'isShowSceneModel', true);
	// 	} else {
	// 		this.isShowSceneModel = false;
	// 	}
	// }

	/** 是否显示切换场景 */
	public getIsShowSceneModel(item: any): boolean {
		if (!item || Object.keys(item).length === 0) {
			return false; // 如果为空,返回false
		}

		return true; // 如果不为空，则会执行到这一步，返回true
	}

	/** 切换语言 */
	public toggleLanguage(): void {
		const currentLang = this.$i18n.locale;

		this.$i18n.locale = currentLang === 'zh' ? 'en' : 'zh';
		// 保存到本地以便下次直接用该语言

		// setCookie(COOKIE_KEY_LANGUAGE, this.$i18n.locale);
		setJarvisLocale(currentLang === 'zh' ? 'en_US' : 'zh_CN');
		// appModule.setLanguage(this.$i18n.locale);

		location.reload();
	}
	
	/** 切换供应商 */
	public async handleVendorChange(value: string): Promise<void> {
		if (!value || String(value) === String(this.previousVendorId)) {
			return;
		}

		// 切换成功后通过 CrossDomainSync 写入当前供应商 ID，实现跨 Tab/子域数据共享
		// 选择"邀请注册"时，跳转到 vendorSwitch 页面并自动展示邀请注册分支
		if (String(value) === String(this.INVITE_REGISTER_VALUE)) {
			// 切换成功后通过 CrossDomainSync 写入当前供应商 ID，实现跨 Tab/子域数据共享
			this.sync.set(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, '');
			reportCrossDomainSyncOperation('set', CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, '');
			configService.setCustomHeadersGetter(() => ({
				'pvendor-id': this.sync.get(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE) || ''
			}));
			// 回滚下拉，避免页面回退后下拉仍显示"邀请注册"
			this.currentVendorId = this.previousVendorId;

				goToRegister();

			return;
		}

		try {
			// 切换成功后通过 CrossDomainSync 写入当前供应商 ID，实现跨 Tab/子域数据共享
			this.sync.set(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, value);
			reportCrossDomainSyncOperation('set', CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE, value);
			configService.setCustomHeadersGetter(() => ({
				'pvendor-id': this.sync.get(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE) || ''
			}));

			// 记录最新成功切换的 id，用于后续切换异常时的回滚
			this.previousVendorId = value;
			this.$message.success(this.$t('切换成功') as string);
			setTimeout(() => {
				window.location.href = '#/home/homePage';
			}, 100);
		} catch (err) {
			// 跨域同步异常：回滚下拉选中状态
			this.currentVendorId = this.previousVendorId;
			this.$message.error(this.$t('切换供应商异常') as string);
		}
	}

	/** 销毁 */
	public beforeDestroy(): void {
		// 关闭指引
		this.driverVal.reset();
	}

	/** 本地测试时用于展示当前是哪个服务器 */
	public getCurrentService(): string {
		const config: IConfig = bootStrapManager.getConfig();
		console.log('this..co', config);
		const defaultChannel: string = config.defaultChannel || '/api';
		let serviceUrl: string = config.proxyTable[defaultChannel].realService;
		serviceUrl = serviceUrl.replace(defaultChannel, '');
		serviceUrl = serviceUrl.replace(/(http|https):\/\//gi, '');

		return `当前连接服务: ${serviceUrl}`;
	}
}
